import { useQuery } from '@tanstack/react-query'
import { useContext, useEffect } from 'react'
import { Link } from 'react-router-dom'

import { QUERY_KEY } from '../../constants'

import { StoresContext } from '../../provider/StoreProvider'

import { getHome } from '../../api/home'

import { Head } from '../../components/head/Head'
import { Wrap } from '../../components/container/Wrap'
import { Content } from '../../components/container/Content'
import { CenterWrap } from '../../components/common'
import { Text } from '../../components/text'
import { Spinner } from '../../components/spinner/Spinner'
import { Header } from '../../components/header'
import { HomeBanner } from './components/HomeBanner'
import { NewsBanner } from './components/NewsBanner'
import { RollingBanner } from './components/RollingBanner'
import { ArticleBanner } from './components/ArticleBanner'
import { Footer } from './components/Footer'

import { Container, FirstGuideContainer, ContentTitle, ContentsContainer, ContentList } from './Home.styled'

import { ReactComponent as NotifyIcon } from '../../assets/gui/notify.svg'
import { ReactComponent as ForwardIcon } from '../../assets/ico/common/arrow/right/arrow_right_black_medium.svg'

const HEAD_INFO = {
  title: '미술품 조각 투자 플랫폼 아티피오',
  description:
    '예스24가 만든 미술품 조각투자 플랫폼 아티피오에서 블루칩 작가의 작품을 함께 소유하고 청약을 통해 나의 자산으로 만들어보세요.',
  ogTitle: '미술품 조각 투자 플랫폼 아티피오',
  ogDescription:
    '예스24가 만든 미술품 조각투자 플랫폼 아티피오에서 블루칩 작가의 작품을 함께 소유하고 청약을 통해 나의 자산으로 만들어보세요.',
  ogUrl: window.location.href,
}

export function Home() {
  const {
    commonStore: { setShowTab, setActiveTab },
  } = useContext(StoresContext)

  const {
    data: home,
    isPending,
    isError,
    refetch,
  } = useQuery({ queryKey: [QUERY_KEY.home], queryFn: getHome, staleTime: 10 * 60 * 1000 })

  useEffect(() => {
    setShowTab(true)
    setActiveTab('home')
  }, [])

  if (isPending || isError) {
    return (
      <>
        <Head {...HEAD_INFO} />
        <Wrap>
          <CenterWrap>
            <Spinner />
          </CenterWrap>
        </Wrap>
      </>
    )
  }

  // const getRevenueRate = () => {
  //   const revenueRate = home.sellHistory?.revenueRate
  //   if (!revenueRate) return '-'
  //   const revenueRateString = amountString(String(revenueRate), false, 2)
  //   return revenueRate > 0 ? `+ ${revenueRateString}%` : `${revenueRateString.replace('-', '- ')}%`
  // }

  return (
    <>
      <Head {...HEAD_INFO} />
      <Wrap>
        <Header type="MAIN" />
        <Content backgroundColor="white" isPullEvent={true} onPull={refetch}>
          <HomeBanner banners={home.homeBanners} />
          <Container>
            <NewsBanner />
            <FirstGuideContainer to="/notice/1">
              <div>
                <div className="notify-icon-box">
                  <NotifyIcon />
                </div>
                <div className="text-box">
                  <Text size={16} weight={500}>
                    <Text size={16} weight={500} color="primary_5">
                      예술품 청약
                    </Text>
                    이 처음이세요?
                  </Text>
                  <Text size={14} weight={500} color="text_secondary">
                    가이드 읽으러 가기
                  </Text>
                </div>
              </div>
            </FirstGuideContainer>
            <RollingBanner banners={home.rollingBanners} />
            <ContentsContainer>
              <ContentTitle>
                <Link to="/contents">
                  <Text size={20} weight={600}>
                    콘텐츠 더보기
                  </Text>
                  <ForwardIcon />
                </Link>
              </ContentTitle>
              <ContentList>
                <ArticleBanner banners={home.articles} />
              </ContentList>
            </ContentsContainer>
            {/* TODO: 추후 주석 해제 */}
            {/* <HistoryContainer>
              <ContentTitle onClick={() => history.push('/market', { listType: MARKET_TAB.SALE_OFF })}>
                <Text size={18} weight={600}>
                  이전 매각 히스토리
                </Text>
                <ForwardIcon />
              </ContentTitle>
              <HistoryCardContainer>
                <Card $padding="16px 24px" $radius={8} $background="white" $shadow="0 4px 6px 0 rgba(0, 0, 0, 0.05)">
                  <GraphIcon />
                  <div>
                    <Text size={12} color="text_secondary">
                      평균 수익률
                    </Text>
                    <Text size={18} weight={600} color="primary_5">
                      {getRevenueRate()}
                    </Text>
                  </div>
                </Card>
                <Card $padding="16px 24px" $radius={8} $background="white" $shadow="0 4px 6px 0 rgba(0, 0, 0, 0.05)">
                  <ClockIcon />
                  <div>
                    <Text size={12} color="text_secondary">
                      평균 보유기간
                    </Text>
                    <Text size={18} weight={600} color="primary_5">
                      {home.sellHistory?.retentionDate || '--'}일
                    </Text>
                  </div>
                </Card>
              </HistoryCardContainer>
            </HistoryContainer> */}
          </Container>
          <Footer />
        </Content>
      </Wrap>
    </>
  )
}
